import React from 'react';
import CollapsibleComponent from 'components/CollapsibleContainer/CollapsibleContainer';
import Text from 'components/Text/Text';
import 'partial/OfferDetails/components/BulletCollapse/BulletCollapse.scss';
import { CSPopover } from 'components/Popover/CSPopover';

export const BulletText = function ({ text, index, sizeClass, datatestid }) {
  return (
    <li className="bulletText">
      <div className="bulletTextItem">
        <Text
          className={sizeClass}
          datatestid={datatestid ? `${datatestid}-bulletItem-${index}` : null}
        >
          <div dangerouslySetInnerHTML={{ __html: text }} />
        </Text>
      </div>
    </li>
  );
};

const BulletCollapse = function ({
  datatestid,
  bulletCollapseTitle,
  bulletList,
  callback,
  isExpanded,
  disclaimer,
  type,
}) {
  return (
    <div className="bulletCollapseContainer">
      <CollapsibleComponent
        datatestid={
          datatestid ? `${datatestid}-bulletListCollapse` : 'bulletListCollapse'
        }
        contentTitle={bulletCollapseTitle}
        expandCallback={callback}
        isExpanded={isExpanded}
      >
        <div className={`bulletContainer ${type}`}>
          <ul>
            {bulletList?.length > 0
              ? bulletList?.map((item, index) => {
                  return (
                    <BulletText
                      key={`${datatestid}-itemKey-${index}`}
                      datatestid={datatestid ? `${datatestid}` : null}
                      text={item}
                      index={index}
                    />
                  );
                })
              : null}
          </ul>
        </div>
        {disclaimer && (
          <div>
            <CSPopover
              content={
                <div
                  data-testid="regularAPR"
                  className="regularAPRText"
                  dangerouslySetInnerHTML={{
                    __html: disclaimer.content,
                  }}
                />
              }
            >
              <div
                data-testid="loanLenderDisclaimer"
                className="bulletDisclaimer"
              >{`${disclaimer.name} Disclaimer`}</div>
            </CSPopover>
          </div>
        )}
      </CollapsibleComponent>
    </div>
  );
};

export default BulletCollapse;
